import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import AttributesList from '../attributesList';
import QuestionnaireChip from '../questionnaireChip';

const useStyles = makeStyles(({ spacing }) => ({
  title: {
    marginBottom: spacing(6),
  },
}));

const SurveySummaryReviews = ({
  className = '', translations,
  survey,
  isQuestionnaireReview,
}) => {

  const classes = useStyles();

  return (
    <div className={className}>
      <Typography className={classes.title} variant="h5">
        {isQuestionnaireReview
          ? translations.questionnaire
          : translations.attributes}
      </Typography>
      {isQuestionnaireReview ? (
        <div>
          <QuestionnaireChip name={survey?.questionnaire?.name} />
        </div>
      ) : (
        <AttributesList
          attributes={survey.attributes}
          isHorizontalList
          isActive
          hasAnswerComment
        />
      )}
    </div>
  );
};

SurveySummaryReviews.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.object.isRequired,
  isQuestionnaireReview: PropTypes.bool.isRequired,
  survey: PropTypes.shape({}).isRequired,
};

export default SurveySummaryReviews;
